import { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSaving, getLastSavedPpsiId } from '../selectors';
import { savePpsi as savePpsiAction } from '../actions';
import { FranchiseType } from '../../../constants/franchiseType';
import { getConfigs } from '../../app/selectors';

const useSavePpsi = () => {
  const [hasSaved, setHasSaved] = useState(false);
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const savedPpsiId = useSelector(getLastSavedPpsiId);
  const franchiseType = useSelector(getConfigs).toJS().franchise;

  const savePpsi = (data, callback) => {
    const id = data.ppsiId;
    const ppsi = _.omit(data, 'ppsiId', 'dish', 'ingredientEntryIds');

    const productAreaData = {
      piaProductArea: data.dish.piaProductArea,
      piaProductAreaName: data.dish.piaProductAreaName,
      piaRangeArea: data.dish.piaRangeArea,
      piaRangeAreaName: data.dish.piaRangeAreaName
    };

    dispatch(
      savePpsiAction(
        id,
        ppsi,
        callback,
        franchiseType !== FranchiseType.INGKA ? { ...productAreaData } : null
      )
    );
    setHasSaved(true);
  };

  return [savePpsi, isSaving, hasSaved ? savedPpsiId : null];
};

export default useSavePpsi;
